import { faWindows } from "@fortawesome/free-brands-svg-icons";

import { ImUserPlus } from "react-icons/im";
import { CiSettings } from "react-icons/ci";

import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { IoOptionsSharp } from "react-icons/io5";
import React, { useEffect, useState } from "react";
import "../index.css";
import { TbReportAnalytics } from "react-icons/tb";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { BiLogOut } from "react-icons/bi";
import { FaUserSecret } from "react-icons/fa6";

import { NotificationContainer } from "react-notifications";
import axios from "axios";
import ProtectedRouteSidebar from "./utils/ProtectedRouteSidebar";
function SideBar({ bar, Handeler_menu, BaseUrl }) {
  const navigate = useNavigate();
  const [data, setdata] = useState({});
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
  };
  useEffect(() => {
    axios
      .get(`${BaseUrl}/user/Accesslevel`, {
        headers: headers,
      })
      .then((res) => {
        console.log(res, "kkkkkk");
      })
      .catch((err) => {});

    axios
      .get(`${BaseUrl}/user/userCurent`, { headers: headers })
      .then((res) => {
        console.log(res, "resssccc");
        setdata(res.data.user);
      })
      .catch((err) => {
        // NotificationManager.error("مشکلی رخ داده است");
      });
  }, []);
  const Handler_logout = () => {
    // axios
    //   .put(`${BaseUrl}/status`, { headers: headers })
    //   .then((res) => {})
    //   .catch((err) => {});
    localStorage.removeItem("TOKEN");
    navigate("/login");
  };
  const Navlinkclass =
    "w-full text-3xl    transition ease-in-out delay-50  hover:text-white hover:-translate-y-1 hover:scale-110  duration-200  cursor-pointer mt-3 hover:bg-gradient-to-r from-sky400 to-sky700  p-2 mr-4 align-middle";

  return (
    <>
      <NotificationContainer />
      <div className="grid grid-cols-12 md:grid-rows-[55px_minmax(500px,_1fr)] md:gap-8 h-screen ">
        {bar ? (
          <div className="col-span-2 row-span-full ">
            <div className="siderbar w-2/12 shadow-lg   shadow-gray-700  rounded-l-md  text-slate-900 h-screen justify-center align-middle fixed top-0 right-0">
              <div className="flex justify-center align-middle">
                <h5 className="text-black mt-12">panel</h5>
                <h1 className="text-4xl text-orange-700 mt-10">T</h1>
              </div>
              <ul className="p-0 m-0 text-center mt-5 w-full">
                <li>
                  <NavLink
                    to={"/"}
                    className={({ isActive }) =>
                      isActive
                        ? `${Navlinkclass} bg-slate-700/50 text-blue-900 flex justify-start rounded-l-full `
                        : `${Navlinkclass} flex justify-start rounded-l-full`
                    }
                  >
                    <FontAwesomeIcon
                      icon={faWindows}
                      className="text-orange-700 mt-1 "
                    />
                    <p className="mr-4 font-bold text-2xl">داشبورد</p>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/InfoPhones"}
                    className={({ isActive }) =>
                      isActive
                        ? `${Navlinkclass} bg-slate-700/50 text-blue-900 flex justify-start rounded-l-full`
                        : `${Navlinkclass} flex justify-start rounded-l-full`
                    }
                  >
                    <IoOptionsSharp className="text-orange-700 mt-1 " />
                    <p className="mr-4 font-bold text-2xl">اطلاعات گوشی</p>
                  </NavLink>
                </li>

                <ProtectedRouteSidebar BaseUrl={BaseUrl}>
                  <li>
                    <NavLink
                      to={"/user"}
                      className={({ isActive }) =>
                        isActive
                          ? `${Navlinkclass} bg-slate-700/50 text-blue-900 flex justify-start rounded-l-full`
                          : `${Navlinkclass} flex justify-start rounded-l-full`
                      }
                    >
                      <ImUserPlus className="text-orange-700 mt-1 " />
                      <p className="mr-4 font-bold text-2xl">افزودن کاربر</p>
                    </NavLink>
                  </li>
                </ProtectedRouteSidebar>
                <li>
                  <NavLink
                    to={"/cmd"}
                    className={({ isActive }) =>
                      isActive
                        ? `${Navlinkclass} bg-slate-700/50 text-blue-900 flex justify-start rounded-l-full`
                        : `${Navlinkclass} flex justify-start rounded-l-full`
                    }
                  >
                    <CiSettings className="text-orange-700 mt-1" />
                    <p className="mr-4 font-bold text-2xl">تولید پیلود</p>
                  </NavLink>
                </li>

                {/* <li>
                  <NavLink
                    to={"/report"}
                    className={({ isActive }) =>
                      isActive
                        ? `${Navlinkclass} bg-slate-700/50 text-blue-900 flex justify-start rounded-l-full`
                        : `${Navlinkclass} flex justify-start rounded-l-full`
                    }
                  >
                    <TbReportAnalytics  className="text-orange-700 mt-1" />
                    <p className="mr-4 font-bold text-2xl">گزارشگیری</p>
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </div>
        ) : (
          <div className="col-span-1 row-span-full  ">
            <div className="siderbar w-28 shadow-gray-700 shadow-lg rounded-l-md text-slate-400 h-screen justify-center align-middle fixed top-0 right-0">
              <div className="flex justify-center align-middle">
                <h5 className="text-black mt-12">panel</h5>
                <h1 className="text-4xl text-orange-700 mt-10">T</h1>
              </div>
              <ul className="p-0 text-center mt-5 w-full flex-col justify-center m-auto">
                <li>
                  <NavLink
                    to={"/"}
                    className={({ isActive }) =>
                      isActive
                        ? `${Navlinkclass} bg-gradient-to-r from-sky400 to-sky700 !rounded-full scale-110 flex justify-center rounded-l-full`
                        : `${Navlinkclass} flex justify-center rounded-l-full`
                    }
                  >
                    <FontAwesomeIcon
                      icon={faWindows}
                      className="text-orange-700 mt-1 "
                    />
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/InfoPhones"}
                    className={({ isActive }) =>
                      isActive
                        ? `${Navlinkclass} bg-gradient-to-r from-sky400 to-sky700 !rounded-full flex justify-center rounded-l-full`
                        : `${Navlinkclass} flex justify-center rounded-l-full`
                    }
                  >
                    <IoOptionsSharp className="text-orange-700 mt-1 " />
                  </NavLink>
                </li>

                <ProtectedRouteSidebar BaseUrl={BaseUrl}>
                  <li>
                    <NavLink
                      to={"/user"}
                      className={({ isActive }) =>
                        isActive
                          ? `${Navlinkclass} bg-gradient-to-r from-sky400 to-sky700 !rounded-full flex justify-start rounded-l-full`
                          : `${Navlinkclass} flex justify-start rounded-l-full`
                      }
                    >
                      <ImUserPlus className="text-orange-700 mt-1 m-auto" />
                    </NavLink>
                  </li>
                </ProtectedRouteSidebar>
                <li>
                  <NavLink
                    to={"/cmd"}
                    className={({ isActive }) =>
                      isActive
                        ? `${Navlinkclass} bg-gradient-to-r from-sky400 to-sky700 !rounded-full flex justify-start rounded-l-full`
                        : `${Navlinkclass} flex justify-start rounded-l-full`
                    }
                  >
                    <CiSettings className="text-orange-700 mt-1 m-auto" />
                  </NavLink>
                </li>

                {/* <li>
                  <NavLink
                    to={"/report"}
                    className={({ isActive }) =>
                      isActive
                        ? `${Navlinkclass} bg-gradient-to-r from-sky400 to-sky700 !rounded-full flex justify-start rounded-l-full`
                        : `${Navlinkclass} flex justify-start rounded-l-full`
                    }
                  >
                    <TbReportAnalytics className="text-orange-700 mt-1 m-auto" />
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </div>
        )}

        <div
          className={`${
            bar
              ? "md:block  col-span-10 w-full"
              : "md:block  col-span-11 w-full"
          }`}
        >
          <section className=" m-2 p-5">
            <div className="row flex justify-between align-middle items-center bg-gradient-to-r from-sky400 to-sky700 px-4 rounded-xl py-1 shadow-lg">
              <div className="">
                <FontAwesomeIcon
                  icon={faBars}
                  className="text-3xl text-slate-900 cursor-pointer text-white"
                  onClick={Handeler_menu}
                />
              </div>
              <div className="flex-col justify-center align-middle">
                <div className="flex justify-center">
                  <span className="w-9 h-9 bg-gray-50 shadow-md rounded-full ml-5 mt-1">
                    <FaUserSecret className="m-auto items-center text-2xl mt-1 text-gray-600" />
                  </span>
                  <h2 className="text-center text-lg text-white mt-2">
                    {data.name}
                  </h2>
                </div>
                <div className="flex items-center">
                  <p className="text-center text-lg text-slate-900 text-white">
                    شما {data.userStatus ? "مدیر" : "کاربر عادی"}سایت هستید
                  </p>
                  <h1 className="text-3xl text-white">/</h1>
                  <span
                    className="w-10 h-10 cursor-pointer flex align-middle"
                    onClick={Handler_logout}
                  >
                    <BiLogOut
                      data-tooltip-target="tooltip-default"
                      className="text-4xl cursor-pointer text-red-600 mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Outlet />
        <div></div>
      </div>
    </>
  );
}

export default SideBar;
